import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/constantes";
import { RootState } from "@store/store";
import { OfertaArrendamiento } from "@pages/producto/credito_simple/oferta/ofertaArrendamiento";
import { OfertaDefault } from "@pages/producto/credito_simple/oferta/OfertaDefault";
import { OfertaFactoraje } from "@pages/producto/credito_simple/oferta/OfertaFactoraje";

/**
 * Despacha a la pantalla de oferta correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla genérica.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.MERCADER_PM]: OfertaArrendamiento,
  [TAX_SYSTEMS_CODES.MERCADER_PFAE]: OfertaArrendamiento,
  [TAX_SYSTEMS_CODES.FLUX_PM]: OfertaFactoraje,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: OfertaFactoraje,
};

export const Oferta = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || OfertaDefault;
  return <Screen />;
};
